// components/subscription/RequestForm/styles.js

import styled from "styled-components";
import { motion } from "framer-motion";

export const ModalContainer = styled.div`
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    overflow-y: auto;
    padding: ${props => props.theme.spacing.xl};
    background: rgba(0, 0, 0, 0.5);
    display: flex;
    align-items: flex-start;
    justify-content: center;
    z-index: 1000;
`;

export const FormWrapper = styled(motion.div)`
    width: 100%;
    max-width: 600px;
    margin: ${props => props.theme.spacing.xl} 0;
    background: white;
    border-radius: ${props => props.theme.borderRadius.lg};
    padding: ${props => props.theme.spacing.xl};
    box-shadow: ${props => props.theme.shadows.lg};
`;

export const FormHeader = styled.div`
    text-align: center;
    margin-bottom: ${props => props.theme.spacing.xl};

    h2 {
        font-size: ${props => props.theme.typography.sizes["2xl"]};
        margin-bottom: ${props => props.theme.spacing.sm};
        color: ${props => props.theme.colors.text.primary};
    }

    p {
        color: ${props => props.theme.colors.text.secondary};
        font-size: ${props => props.theme.typography.sizes.md};
    }
`;

export const FormGroup = styled.div`
    margin-bottom: ${props => props.theme.spacing.lg};

    label {
        display: block;
        margin-bottom: ${props => props.theme.spacing.xs};
        font-weight: ${props => props.theme.typography.weights.medium};
        color: ${props => props.theme.colors.text.primary};
    }
`;

export const PlanSummary = styled.div`
    background: ${props => props.theme.colors.background.alt};
    padding: ${props => props.theme.spacing.lg};
    border-radius: ${props => props.theme.borderRadius.lg};
    margin-bottom: ${props => props.theme.spacing.xl};

    h3 {
        font-size: ${props => props.theme.typography.sizes.lg};
        margin-bottom: ${props => props.theme.spacing.sm};
        color: ${props => props.theme.colors.text.primary};
    }
`;

export const ButtonGroup = styled.div`
    display: flex;
    gap: ${props => props.theme.spacing.md};
    margin-top: ${props => props.theme.spacing.xl};

    button {
        flex: 1;
    }
`;

export const CreditInfoSection = styled.div`
    margin-top: ${props => props.theme.spacing.md};
    padding: ${props => props.theme.spacing.md};
    background: white;
    border-radius: ${props => props.theme.borderRadius.md};

    .credit-detail {
        display: flex;
        justify-content: space-between;
        margin-bottom: ${props => props.theme.spacing.xs};
        
        &:last-child {
            margin-bottom: 0;
        }

        .label {
            color: ${props => props.theme.colors.text.secondary};
            font-size: ${props => props.theme.typography.sizes.sm};
        }

        .value {
            font-weight: ${props => props.theme.typography.weights.medium};
            color: ${props => props.theme.colors.text.primary};
        }
    }
`;

export const InfoText = styled.p`
    font-size: ${props => props.theme.typography.sizes.sm};
    color: ${props => props.theme.colors.text.secondary};
    margin-top: ${props => props.theme.spacing.xs};
    font-style: italic;
`;

export const PriceBreakdown = styled.div`
    margin-top: ${props => props.theme.spacing.lg};
    padding-top: ${props => props.theme.spacing.lg};
    border-top: 1px solid ${props => props.theme.colors.border};
`;

export const PriceBreakdownItem = styled.div`
    display: flex;
    justify-content: space-between;
    margin-bottom: ${props => props.theme.spacing.sm};
    font-size: ${props => props.theme.typography.sizes.md};
    color: ${props => props.isDiscount ? props.theme.colors.success.main : 
                      props.isTotal ? props.theme.colors.text.primary : 
                      props.theme.colors.text.secondary};
    
    ${props => props.isTotal && `
        font-weight: ${props.theme.typography.weights.bold};
        font-size: ${props.theme.typography.sizes.lg};
        margin-top: ${props.theme.spacing.md};
        padding-top: ${props.theme.spacing.md};
        border-top: 1px dashed ${props.theme.colors.border};
    `}
`;

export const PeriodInfo = styled.div`
    display: inline-block;
    padding: ${props => props.theme.spacing.xs} ${props => props.theme.spacing.sm};
    border-radius: ${props => props.theme.borderRadius.full};
    font-size: ${props => props.theme.typography.sizes.sm};
    margin-bottom: ${props => props.theme.spacing.md};
    
    background: ${props => {
        switch (props.interval) {
            case 'quarterly':
                return props.theme.colors.success.main + '20';
            case 'bimonthly':
                return props.theme.colors.warning.main + '20';
            default:
                return props.theme.colors.primary.main + '20';
        }
    }};
    
    color: ${props => {
        switch (props.interval) {
            case 'quarterly':
                return props.theme.colors.success.main;
            case 'bimonthly':
                return props.theme.colors.warning.main;
            default:
                return props.theme.colors.primary.main;
        }
    }};
`;


export const ErrorMessage = styled.div`
    color: ${props => props.theme.colors.error.main};
    background: ${props => props.theme.colors.error.light}20;
    padding: ${props => props.theme.spacing.md};
    border-radius: ${props => props.theme.borderRadius.md};
    margin-bottom: ${props => props.theme.spacing.lg};
    font-size: ${props => props.theme.typography.sizes.sm};
`;